import NextHead from 'next/head';
import type { PropsWithChildren } from 'react';
import React from 'react';

export interface HeadProps extends PropsWithChildren {}
const Head: React.FC<HeadProps> = ({ children }) => <NextHead>{children}</NextHead>;

export default Head;
